import VestingContext from "contexts/VestingContext";
import { useContext } from "react";

const useVesting = () => useContext(VestingContext);

export default useVesting;
